import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProfileProvider } from './contexts/ProfileContext';
import { NotificationProvider } from './contexts/NotificationContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import AuthCallback from './pages/AuthCallback';
import MCPServers from './pages/MCPServers';
import Workflows from './pages/Workflows';
import LearnMore from './pages/LearnMore';
import Art from './pages/Art';
import Team from './pages/Team';
import Cart from './pages/Cart';
import AdminDashboard from './pages/AdminDashboard';
import UserProfile from './pages/UserProfile';
import UnderConstruction from './pages/UnderConstruction';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  // Safety mechanism: Clear any potentially invalid tokens on app startup
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // Check if token is malformed or suspicious
      try {
        const parts = token.split('.');
        if (parts.length !== 3) {
          console.warn('Invalid token format detected, clearing localStorage');
          localStorage.clear();
        }
      } catch (error) {
        console.warn('Error validating token, clearing localStorage');
        localStorage.clear();
      }
    }
  }, []);
  return (
    <AuthProvider>
      <CartProvider>
        <ThemeProvider>
          <ProfileProvider>
            <NotificationProvider>
              <Router>
                <ScrollToTop />
                <div className="App">
                  <Header />
                  <main className="main-content">
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/register" element={<Register />} />
                      <Route path="/auth/callback" element={<AuthCallback />} />
                      <Route path="/mcp-servers" element={<MCPServers />} />
                      <Route path="/workflows" element={<Workflows />} />
                      <Route path="/learn-more" element={<LearnMore />} />
                      <Route path="/art" element={<Art />} />
                      <Route path="/team" element={<Team />} />
                      <Route path="/under-construction" element={<UnderConstruction />} />
                      <Route 
                        path="/cart" 
                        element={
                          <ProtectedRoute>
                            <Cart />
                          </ProtectedRoute>
                        } 
                      />
                      <Route 
                        path="/profile" 
                        element={
                          <ProtectedRoute>
                            <UserProfile />
                          </ProtectedRoute>
                        } 
                      />
                      <Route 
                        path="/admin" 
                        element={
                          <ProtectedRoute requireAdmin={true}>
                            <AdminDashboard />
                          </ProtectedRoute>
                        } 
                      />
                    </Routes>
                  </main>
                  <Footer />
                </div>
              </Router>
            </NotificationProvider>
          </ProfileProvider>
        </ThemeProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
